import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { guestUserLoginApi } from "../apis/onboarding/OnBoardingApis";

import { IRoleType } from "@/models/role";
import { ISessionKeys } from "@/models";

import { storage } from "../Storage";
import { useAppDispatch } from "@/store/hooks";
import { setIsLocationAccessOpen } from "@/store/slices/config";
export const useGuestLogin = () => {
  const [guestUserLoading, setGuestUserLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const guestUserLogin = async () => {
    setGuestUserLoading(true);
    try {
      const response = await guestUserLoginApi();
      if ("result" in response) {
        const { role, token } = response.result;
        if (role === IRoleType.GUEST) {
          const sessionKeys = [ISessionKeys.TOKEN, ISessionKeys.ROLE_TYPE];
          const values = [token, role];
          sessionKeys.map((key, index) =>
            storage.setSessionToken(key, values[index])
          );
          dispatch(setIsLocationAccessOpen(true));
          navigate("/home");
        }
      }
    } catch (error) {
      console.error("Guest login failed:", error);
    } finally {
      setGuestUserLoading(false);
    }
  };

  return { guestUserLogin, guestUserLoading };
};
